import { makeVar } from '@apollo/client';

export const rowStatesVar = makeVar({});

export const updateRowState = (rowId, newState) => {
  const current = rowStatesVar();

  if (current[rowId] === newState) {
    return current;
  }

  const updated = {
    ...current,
    [rowId]: newState,
  };

  rowStatesVar(updated);
  return updated;
};

export const getRowState = (rowId) => {
  const current = rowStatesVar();
  return current[rowId] || false;
};

export const resetAllRowStates = () => {
  rowStatesVar({});
};

export const getRowStates = () => rowStatesVar();
